// extracted by mini-css-extract-plugin
export default {"container":"rngu7v","stripes":"_Y5WGP","block":"LHeCVK","text":"DTdgtp"};